export default __webpack_public_path__ + "static/carden-6481676e70c0075d0005bb67341450ed.svg";